import { render, staticRenderFns } from "./SpellcheckerCorrections.vue?vue&type=template&id=4ad9cf9c&scoped=true"
import script from "./SpellcheckerCorrections.vue?vue&type=script&lang=js"
export * from "./SpellcheckerCorrections.vue?vue&type=script&lang=js"
import style0 from "./SpellcheckerCorrections.vue?vue&type=style&index=0&id=4ad9cf9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad9cf9c",
  null
  
)

export default component.exports